// material-ui
import { Grid } from '@mui/material';

import logoicon from 'assets/images/logoicon.png';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {

  return (
    /**
     * if you want to use image instead of svg uncomment following, and comment out <svg> element.
     *
     * <img src={logo} alt="Mantis" width="100" />
     *
     */
    <>
      <Grid item xs={12} display="flex"
            justifyContent="center"
            alignItems="center" sx={{ margin: 'auto' }}>
           <img src={logoicon} alt="KiT" width="100" />
      </Grid>
    </>
  );
};

export default Logo;
